<template>
	<div class="m-total m-module flex-column flex-grow">
		<div class="bg" :style="{'background-image': background ? `url('${background}')` : ''}"></div>
		<div class="main flex-column flex-center">
			<p>{{mainTotal.title || '-'}}</p>
			<ul class="flex">
				<li v-for="(item, i) in mainValue" :key="i" class="flex-center"><span :style="{'opacity': item == 0 ? .15 : 1}">{{item}}</span></li>
			</ul>
		</div>
		<div class="list">
			<ul v-for="(row, i) in totalList" :key="i" class="flex">
				<li v-for="(item, j) in row" :key="j" class="flex-grow flex-column flex-center">
					<ins></ins><ins></ins><ins></ins><ins></ins>
					<strong :style="{'color': `var(--color-${item.color})`}">{{item.value || 0}}</strong>
					<p>{{item.title}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import module from './digital_module.vue'

	export default {
		components: {
			module
		},

		props: {
			id: [Number, String]
		},

		data() {
			return {
				mainTotal: {},
				totalList: [],
				background: ''
			}
		},


		computed: {
			mainValue() {
				let val = (this.mainTotal.value || 0).toString().split('');
				if (val.length < 6) {
					val = new Array(6 - val.length).fill('0').concat(val);
				}
				return val;
			}
		},

		mounted() {
			this.update()
		},
		
		beforeDestroy() {
			clearTimeout(this._updateTimer);
		},

		methods: {
			update() {
				this.request({
					url: '/digital/getData',
					data: {
						digital_id: this.$parent.digitalId,
						module_id: this.id
					},
					success: data => {
						this.mainTotal = data.childModule.main;
						this.totalList = [];
						this.totalList.push(data.childModule.list.splice(0, 2));
						this.totalList.push(data.childModule.list);
						this.background = data.childModule.background;
						this.$nextTick(() => {
							this.numberStep(this.mainTotal.value, this.mainTotal.data, val => {
								this.$set(this.mainTotal, 'value', val);
							});
							this.totalList.forEach(group => {
								group.forEach(item => {
									this.numberStep(item.value, item.data, val => {
										this.$set(item, 'value', val);
									});
								});
							});
						});
						this._updateTimer = setTimeout(this.update, 300000);
					},
					fail: () => {
						this._updateTimer = setTimeout(this.update, 300000);
					}
				})
			},

			numberStep(start = 0, end, fun, after) {
				let dir = start < end ? 1 : -1;
				let diff = Math.abs(parseInt(end - start));
				let num = 0, gradient = diff / 40;
				
				!function loop() {
					if (num < diff) {
						num = Math.min(diff, num + gradient);
						fun(parseInt(start + dir * num));
						setTimeout(loop, 20);
					} else {
						after && after();
					}
				}();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@font-face {
	    font-family: 'digital';
	    src: url('https://mes-saas-open-dev.oss-cn-hangzhou.aliyuncs.com/static/ycmes/font/DingTalk-JinBuTi.ttf') format('truetype');
	}

	.m-total {
		position: relative;
		font-family: 'digital';

		&:before {
			content: '';
			position: absolute;
			left: -.4rem;
			right: 0;
			top: 0;
			bottom: 0;
			background-image: url('~@/assets/image/digital/total_border_left.png');
			background-repeat: no-repeat;
			background-position: left top;
			background-size: auto 100%;
			pointer-events: none;
		}

		&:after {
			content: '';
			position: absolute;
			left: 0;
			right: -.4rem;
			top: 0;
			bottom: 0;
			background-image: url('~@/assets/image/digital/total_border_right.png');
			background-repeat: no-repeat;
			background-position: right top;
			background-size: auto 100%;
			pointer-events: none;
		}

		.bg {
			position: absolute;
			left: .35rem;
			right: .35rem;
			top: 0;
			bottom: 0;
			background-image: url('~@/assets/image/digital/total_bg.png');
			background-repeat: no-repeat;
			background-position: left bottom;
			background-size: 100% auto;
			opacity: .6;
			pointer-events: none;
		}

		.main {
			position: relative;
			color: #00FFFF;
			
			p {
				margin: .06rem 0 .18rem;
				font-size: .2rem;
			}
			
			ul {
				height: .55rem;

				li {
					position: relative;
					width: .48rem;
					height: .55rem;
					background-image: linear-gradient(0deg, #034245, #00FFFF, #034245);
					font-size: .44rem;

					&:nth-child(n+2) {
						margin-left: .1rem;
					}

					&:before {
						content: '';
						position: absolute;
						left: 1px;
						right: 1px;
						top: 1px;
						bottom: 1px;
						background: #021138;
					}

					span {
						position: relative;
					}
				}
			}
		}

		.list {
			padding: .35rem;

			ul {
				margin-bottom: .22rem;

				&:nth-child(1) li:nth-child(n+2) {
					margin-left: .28rem;
				}

				&:nth-child(2) li:nth-child(n+2) {
					margin-left: .18rem;
				}

				li {
					position: relative;
					height: 1.1rem;
					background: rgba(11,49,85,.6);

					strong {
						font-size: .36rem;
						font-weight: normal;
						color: #fff;
					}

					p {
						margin-top: .1rem;
						font-size: .13rem;
						color: #93B8D9;
					}

					ins {
						position: absolute;
						width: .08rem;
						height: .08rem;

						&:nth-child(1) {
							left: 0;
							top: 0;
						}

						&:nth-child(2) {
							right: 0;
							top: 0;
							transform: rotate(90deg);
						}

						&:nth-child(3) {
							right: 0;
							bottom: 0;
							transform: rotate(180deg);
						}

						&:nth-child(4) {
							left: 0;
							bottom: 0;
							transform: rotate(-90deg);
						}

						&:before {
							content: '';
							position: absolute;
							left: 0;
							top: 0;
							width: .08rem;
							height: 1px;
							background: #73A8E6;
						}

						&:after {
							content: '';
							position: absolute;
							left: 0;
							top: 0;
							width: 1px;
							height: .08rem;
							background: #73A8E6;
						}
					}
				}
			}
		}
	}
</style>
